export const partnerConfig = {
  '327e1eba-2468-48fe-a69d-cf59e431e96d': {
    title: 'Powered by Miracle Mom and Practo',
    partnerName: 'miraclemom',
    partnerLogo: 'miraclemom.svg',
    partnerLogoAlt: 'Miracle Mom',
  },
};
